module.exports = __webpack_public_path__ + "img/1 (36).1f269adc.png";